import { DISCORD_INVITE } from '@shefira/shared';

import { hudBar, iconButton } from './hud.js';
import { uiText } from './text.js';

export { DISCORD_INVITE };

const LABEL = 'Rejoindre le Discord';

/** The link of the version line, under the logo of the screens before the game. */
export function discordLink(): HTMLAnchorElement {
  const link = document.createElement('a');
  link.className = 'version-line__discord';
  link.href = DISCORD_INVITE;
  link.target = '_blank';
  link.rel = 'noopener';
  link.title = uiText(LABEL);
  const icon = document.createElement('span');
  icon.className = 'version-line__discord-icon';
  icon.setAttribute('aria-hidden', 'true');
  link.append(icon, 'Discord');
  return link;
}

/** One button for the whole visit: a zone change or a reconnect reuses it. */
let button: HTMLButtonElement | undefined;

/**
 * The HUD button of the top row, among what leads out of the game; the
 * settings gear, mounted after it, stays last. Built once: on a touch screen
 * the drawer holds it (touch-hud.ts), so the row alone cannot tell it exists.
 */
export function showDiscordButton(): void {
  button ??= (() => {
    const created = iconButton('discord', LABEL);
    created.classList.add('hud-button--discord');
    created.addEventListener('click', () => {
      window.open(DISCORD_INVITE, '_blank', 'noopener');
    });
    return created;
  })();
  hudBar('top').append(button);
}
